import { render, staticRenderFns } from "./BannerBox.vue?vue&type=template&id=cb26509c&scoped=true&"
import script from "./BannerBox.vue?vue&type=script&lang=js&"
export * from "./BannerBox.vue?vue&type=script&lang=js&"
import style0 from "./BannerBox.vue?vue&type=style&index=0&id=cb26509c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb26509c",
  null
  
)

export default component.exports